import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { FormCheckbox, FormInput, Loader, Tooltip } from 'components';
import { routes } from 'router';
import { appService } from 'services';

const LoginForm = () => {
  const { t } = useTranslation();
  const isRedirection = appService.isRedirection();
  const {
    formState: { isValid },
    isLoading,
    loginLoading,
    onSubmit,
    submitClasses
  } = useFormContext();

  return (
    <>
      <h1 className="h1 underlined-yellow mb-6">{t('auth:login.title', { brand: appService.brand() })}</h1>

      <form onSubmit={onSubmit} className="mb-6">
        <div className="relative">
          <FormInput
            name="userId"
            label={t('form:userId')}
            rules={{ required: true }}
            helpMessage={appService.isTouloisirs() ? t('form:userIdHelpMessage') : null}
            placeholder={t('form:userId')}
            icon={{ name: 'id-badge', style: 'fad' }}
            dataTestId="loginUserId"
          />

          <Tooltip className="absolute right-2 top-11" content={t('auth:login.userIdTooltip')} id="login-help" />
        </div>
        <FormInput
          name="password"
          label={t('form:password')}
          type="password"
          rules={{ required: true }}
          className="my-6 block"
          autoComplete="current-password"
          placeholder={t('form:password')}
          icon={{ name: 'lock' }}
          dataTestId="loginPassword"
        />

        <FormCheckbox name="rememberMe" labelI18nKey="form:rememberMe" />

        <button
          type="submit"
          disabled={!isValid || isLoading || loginLoading}
          className={submitClasses}
          data-test-id="loginSubmit"
        >
          {(isLoading || loginLoading) && <Loader loaderClass="w-4 h-4 text-white mr-2" />}
          {t('auth:login.button')}
        </button>
      </form>
      {!isRedirection && (
        <>
          <div className="text-center mb-14 block-divider">
            <p>{t('auth:forgotPassword.label')}</p>

            <Link to={routes.forgotPassword.path} className="underline text-primary-500 hover:no-underline">
              {t('auth:forgotPassword.link')}
            </Link>
          </div>

          <h2 className="h2 underlined-yellow">{t('auth:registration.title')}</h2>

          <p className="my-6">{t('auth:registration.firstRegister')}</p>

          <Link to={routes.registration.path} className="btn outlined mx-auto mb-6" data-test-id="registerBtn">
            {t('auth:registration.title')}
          </Link>
        </>
      )}
    </>
  );
};

export default LoginForm;
